<template>
    <div>
        <b-modal
            ref="modalEdit"
            hide-footer
            :title="titleModal"
            size="md"
            no-close-on-backdrop
            hide-header-close
            hide-header
        >
            <div class="title-modal">
                <div class="title-text-modal">{{ titleModal }}</div>
                <div
                    class="float-right btn-hover-modal"
                    @click="closeModal"
                >
                    <xIcon/>
                </div>
            </div>
            <div class="modal-edicao mb-3 modal-edicao-label mt-6">
                <b-row class="mb-3">
                    <b-col class="d-block text-parcela">
                        <span class="label-conta">Categoria Produto</span>
                        <b-form-input
                            name="description-conta"
                            class="modal-edicao-input"
                            type="text"
                            v-model="productClassSelected.description"
                            autocomplete="off"
                            placeholder="Digite o nome da categoria"
                            v-validate="'required|maxLength:100'"
                            :state="validateState('description-conta')"
                        />
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col class="d-block text-parcela">
                        <span class="label-conta">Referência</span>
                        <b-form-input
                            name="reference-conta"
                            class="modal-edicao-input"
                            type="text"
                            v-model="productClassSelected.reference"
                            autocomplete="off"
                            placeholder="Digite a referência"
                            v-validate="'maxLength:100'"
                            :state="validateState('reference-conta')"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="d-block text-parcela center">
                        <span class="label-conta toggle-conta">Serviço</span>
                        <ToggleSwitch
                            name="conta-close-monthly"
                            class="toggle-conta"
                            :value="productClassSelected.service"
                            @toggle="_ => changeToggle('service')"
                        />
                    </b-col>
                </b-row>
            </div>
            <b-button class="ml-1 mt-3 float-left btn-modal btn-cancel" @click="closeModal">Cancelar</b-button>
            <b-button class="mt-3 float-left btn-modal btn-limpar" @click="cleanModal">Limpar</b-button>
            <b-button
                class="mt-3 ml-1 float-right btn-modal btn-salvar"
                @click="saveRecord"
                :disabled="invalidForm || saving"
            >
                Salvar
            </b-button>
        </b-modal>
    </div>
</template>

<script>
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { ProductClassService } from "../../services/productClass";
	import emitter from "@/eventBus.js";
	import ToggleSwitch from "@/components/ToggleSwitch";
	import { mapState } from "vuex";

	export default {
		components: {
			ToggleSwitch
		},

		props: {
			productClassData: {
				type: Object,
				required: false
			},
			name: {
				type: String,
				required: false
			}
		},

		inject: ["parentValidator"],

		data () {
			return {
				titleModal: "",
				productClassSelected: {
					idProductClass: "",
					description: "",
					reference: "",
					service: false
				},
				productClassService: new ProductClassService(),
				loading: true,
				noEditProductClass: false,
				invalidForm: true,
				saving: false

			};
		},

		computed: {
			...mapState(["productClass"])
		},

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);
			this.showProductClass();
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			showProductClass () {
				this.invalidForm = true;
				const {
					idProductClass = "",
					description = "",
					reference = "",
					service = false
				} = this.productClassData;

				if (!idProductClass) {
					this.productClassSelected.description = this.name;
					this.titleModal = "Cadastrar Nova Categoria de Produtos";
					this.noEditProductClass = true;
				} else {
					this.productClassSelected.description = description;
					this.titleModal = "Editar Categoria de Produtos";
					this.noEditProductClass = false;
				}

				this.productClassSelected.idProductClass = idProductClass;
				this.productClassSelected.reference = reference;
				this.productClassSelected.service = service;
				this.$refs.modalEdit.show();
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields);
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			closeModal () {
				this.$refs.modalEdit.hide();
				this.cleanModal();
				this.productClassSelected.idProductClass = "";
				this.saving = false;
				this.invalidForm = true;
				this.$emit("closeModal");
			},

			cleanModal () {
				this.productClassSelected.description = "";
				this.productClassSelected.reference = "";
				this.productClassSelected.service = false;
			},

			async saveRecord () {
				const invalidFields = await this.validateModal();
				if (invalidFields) {
					await this.$swal({
						title: "Formulário Inválido",
						text: "Existe informação sem preencher!",
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						confirmButtonText: "OK",
						reverseButtons: true
					});
					return;
				}

				if (await this.recordExist()) {
					return;
				}

				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};
				const payload = {
					description: this.productClassSelected.description,
					reference: this.productClassSelected.reference,
					service: this.productClassSelected.service
				};

				if (this.productClassSelected.idProductClass)
					payload.idProductClass = this.productClassSelected.idProductClass;

				this.$snotify.async("Aguarde...", "Salvando", async () => {
					try {
						this.saving = true;
						const newProductClass = await this.productClassService.upsertProductClass({payload});

						this.$emit("findProductClass", true);
						this.$emit("newProductClass", newProductClass);
						emitter.emit("reloadProductClass", { reload: true });
						this.closeModal();

						return {
							title: "Sucesso!",
							body: "Categoria de produtos salva com sucesso.",
							config
						};
					} catch (error) {
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar salvar categoria de produtos!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			async validateModal () {
				const validationFields = Object.keys(this.veeFields);
				if (!validationFields.length)
					return true;

				const validations = validationFields.reduce((acc, ref) => {
					if (this.veeFields[ref] && this.veeFields[ref].invalid)
						return [...acc, this.veeFields[ref].invalid];

					return acc;
				}, []);

				const invalidFields = validations.filter(field => field);
				return Boolean(invalidFields && invalidFields.length);
			},

			changeToggle (key) {
				this.productClassSelected[key] = !this.productClassSelected[key];
			},

			async recordExist () {
				const recordExist = this.productClass.find(pc => pc.description === this.productClassSelected.description && this.productClassSelected.idProductClass !== pc.idProductClass);
				if (recordExist) {
					await this.$swal({
						title: "Registro já existe",
						text: "Não é possível criar o registro, altere o nome e tente novamente.",
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						confirmButtonText: "OK",
						reverseButtons: true
					});
					return true;
				}

				return false;
			}
		}
	};
</script>